import {
  Disclaimer,
  lightTheme,
  Pill,
  PosConnectionType,
  ProviderConnectionType,
  renderPosConnectionTypeName,
  renderProviderConnectionTypeName,
} from '@vgrubs/components';

export const ProviderConnectionTypeComponent = ({
  connectionType,
  shortText = false,
}: {
  connectionType: ProviderConnectionType;
  shortText?: boolean;
}) => {
  const fullText = renderProviderConnectionTypeName(connectionType) || '';

  return (
    <Pill
      $background={shortText ? lightTheme.mediumGray : lightTheme.darkGray}
      $minWidth={shortText ? '22px' : '70px'}
      $minWidthSM={shortText ? '22px' : '50px'}
      $padding={shortText ? '0' : undefined}
      $height={shortText ? '22px' : undefined}
    >
      <Disclaimer $m="0" $color={lightTheme.white}>
        {shortText ? fullText.charAt(0) : fullText}
      </Disclaimer>
    </Pill>
  );
};

export const PosConnectionTypeComponent = ({
  connectionType,
  shortText = false,
}: {
  connectionType: PosConnectionType;
  shortText?: boolean;
}) => {
  const fullText = renderPosConnectionTypeName(connectionType) || '';

  return (
    <Pill
      $background={lightTheme.lightGray}
      $minWidth={shortText ? '24px' : '70px'}
      $padding={shortText ? '0 4px' : undefined}
    >
      <Disclaimer $m="0" $color={lightTheme.white}>
        {shortText ? fullText.charAt(0) : fullText}
      </Disclaimer>
    </Pill>
  );
};
